import { render, staticRenderFns } from "./consumerScancodeLists.vue?vue&type=template&id=4924a8b1&scoped=true&"
import script from "./consumerScancodeLists.vue?vue&type=script&lang=js&"
export * from "./consumerScancodeLists.vue?vue&type=script&lang=js&"
import style0 from "./consumerScancodeLists.vue?vue&type=style&index=0&id=4924a8b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4924a8b1",
  null
  
)

export default component.exports